import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/clubOwner/$id/_club/profile_/_profile')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/' });
    }
  }
});
